import { MobileStepper, styled } from '@mui/material';

export const StyledMobileStepper = styled(MobileStepper)(() => ({
	width: '100%',
	display: 'flex',
	justifyContent: 'center',

	'&.MuiPaper-root': {
		margin: 0,
	},
}));
